import { FC } from "react"

import { BLOCK_DEFINITIONS } from "./helpers/blockRegistry"
import { PromotionBlock } from "./types/types"

type Props = {
  block: PromotionBlock
  onChange: (patch: Partial<PromotionBlock>) => void
}

export const BlockRenderer: FC<Props> = ({ block, onChange }) => {
  const def = BLOCK_DEFINITIONS[block.type]

  if (!def) return null

  const Editor = def.Editor
  return <Editor block={block} onChange={onChange} />
}
